export var NotebookSortField;
(function (NotebookSortField) {
    NotebookSortField["NOTEBOOK_SORT_FIELD_CREATED_AT"] = "createdAt";
    NotebookSortField["NOTEBOOK_SORT_FIELD_UPDATED_AT"] = "updatedAt";
    NotebookSortField["NOTEBOOK_SORT_FIELD_NAME"] = "name";
})(NotebookSortField || (NotebookSortField = {}));
